import React, { MouseEventHandler, useState } from 'react'
import { useIsMounted } from 'usehooks-ts'

import { fetchApi } from '@hozana/api/fetchApi'
import { Translate } from '@hozana/intl/Translate'
import { useDispatch } from '@hozana/redux/hooks'

import { Button } from 'elements/button/Button'
import { Space } from 'elements/layout/Space'
import { Transition } from 'elements/motion/Transition'
import { P } from 'elements/text/P'
import { Alert } from 'elements/ui/Alert'

import { requestPasswordRecoveryMutation } from 'modules/auth/queries'

export type TDefinePasswordSectionProps = {
  show: boolean
  email: string
  solidButton?: boolean
}

export const DefinePasswordSection: TFCC<TDefinePasswordSectionProps> = ({ children, show, email, solidButton }) => {
  const dispatch = useDispatch()
  const isMounted = useIsMounted()

  const [buttonClicked, setButtonClicked] = useState(false)
  const [emailSent, setEmailSent] = useState(false)

  const handleClick: MouseEventHandler<HTMLButtonElement> = () => {
    setButtonClicked(true)
    dispatch(fetchApi(requestPasswordRecoveryMutation({ email }))).then(() => {
      if (isMounted) {
        setEmailSent(true)
      }
    })
  }

  return (
    <Transition initial={{ height: '0px' }} final={{ height: '300px' }} active={show}>
      <Space h="1em" />
      {emailSent ? (
        <Alert status="info" hideCloseButton p="10px">
          <P>
            <Translate values={{ email }} components={{ bold: <strong /> }}>
              trans:auth:auth.login.password-email-sent
            </Translate>
          </P>
        </Alert>
      ) : (
        <>
          <P m="0 0 5px">{children}</P>
          <Button
            {...(solidButton
              ? {
                  colors: 'darkBlue',
                }
              : {
                  colors: 'greyTransparent',
                  color: 'blue',
                  hoverColor: 'darkBlue',
                  bold: false,
                })}
            onClick={handleClick}
            type="button"
            loading={buttonClicked}
            m="10px 0"
          >
            trans:auth:words.password.define
          </Button>
        </>
      )}
      <Space h="10px" />
    </Transition>
  )
}
